<nb-toggle
  [checked]="getBilled()"
  status="primary"
  [disabled]="!$disabled | async"
  (checkedChange)="onBilledChanged($event)"></nb-toggle>
